"use client";

import * as React from "react";
import { TrendingUp } from "lucide-react";
import { Label, Pie, PieChart } from "recharts";

import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "../../components/ui/chart";

export function DonutWithText({
  chartData = [],
  chartConfig = [],
  titleText = "Pie Chart - Donut",
  descriptionText,
  centerLabel = "",
  footerPrimary,
  footerSecondary,
}) {
  // Sum of all values
  const totalValue = React.useMemo(
    () => chartData.reduce((sum, slice) => sum + slice.value, 0),
    [chartData]
  );

  return (
    <Card className="flex flex-col">
      <CardHeader className="flex-row items-center justify-between pb-0">
        <CardTitle className="text-xl text-start font-semibold">
          {titleText}
        </CardTitle>
        {descriptionText && (
          <CardDescription>{descriptionText}</CardDescription>
        )}
      </CardHeader>
      <CardContent className="flex-1 pb-0">
        <ChartContainer
          config={chartConfig}
          className="mx-auto aspect-square max-h-[350px]"
        >
          <PieChart>
            <ChartTooltip
              cursor={false}
              content={<ChartTooltipContent hideLabel />}
            />
            <Pie
              data={chartData}
              dataKey="value"
              nameKey="name"
              innerRadius={80}
              strokeWidth={5}
            >
              <Label
                content={({ viewBox }) => {
                  if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                    return (
                      <text
                        x={viewBox.cx}
                        y={viewBox.cy}
                        textAnchor="middle"
                        dominantBaseline="middle"
                      >
                        <tspan
                          x={viewBox.cx}
                          y={viewBox.cy}
                          className="fill-foreground text-3xl font-bold"
                        >
                          {totalValue.toLocaleString()}
                        </tspan>
                        {centerLabel && (
                          <tspan
                            x={viewBox.cx}
                            y={(viewBox.cy || 0) + 24}
                            className="fill-muted-foreground"
                          >
                            {centerLabel}
                          </tspan>
                        )}
                      </text>
                    );
                  }
                }}
              />
            </Pie>
          </PieChart>
        </ChartContainer>
      </CardContent>
      {(footerPrimary || footerSecondary) && (
        <CardFooter className="flex-col gap-2 text-sm">
          {footerPrimary && (
            <div className="flex items-center gap-2 font-medium leading-none">
              {footerPrimary}
            </div>
          )}
          {footerSecondary && (
            <div className="leading-none text-muted-foreground">
              {footerSecondary}
            </div>
          )}
        </CardFooter>
      )}
    </Card>
  );
}
